module.exports = __webpack_public_path__ + "assets/img/12.ac3dc06a.png";